import { connect } from 'react-redux';

import {
  activateReceiveQuestionsNotification,
  getAllRates,
  loadPossibleCyclesForUser,
  loadUserSubscription,
  setFlashSectionChoose,
  updateRatingExam,
} from '../actions/accountSettingsAction';
import {
  checkDailyQuizStatus,
  checkQualDailyQuizStatus,
  setDailyQuiz,
  setDailyTimeOut,
  setInitialTime,
  setQualDailyQuiz,
  startTimer,
  updateTimer,
} from '../actions/dailyQuizActions';
import {
  openPdfViewer,
  setOneQualDailyQuizHistoryAction,
} from '../actions/dashboardActions';
import { setShowMobileMenu } from '../actions/mainAction';
import { activateSubscription } from '../actions/manageSubscriptionActions';
import { getWeeklyPracticeExams } from '../actions/practiceExamActions';
import { getPdfByReference, setBackTo } from '../actions/studyMainActions';
import { getLoggedStudent } from '../actions/userActions';
import {
  getAllPublicRates,
  getPossibleCyclesForUser,
  getQuestionNotificationSelector,
  getSwitchPfeSkt,
  getUpdateRatingExamMessage,
  getUpdateRatingExamWaiting,
  getUserSubscription,
} from '../components/AccountSettings/AccountSettingsSelectors';
import {
  getCheckDailyQuizStatusWaiting,
  getDailyQuizRunning,
  getDailyTimeOut,
  getIsQualDailyQuizLoading,
  getIsQualDailyQuizRunning,
  getNextQualDailyQuizIn,
  getNextQuizIn,
  getProgress,
  getQualDailyQuizDailyTimeOut,
  getQualDailyQuizProgress,
  getQuiz,
  quizAvailableSelector,
  timerSelector,
} from '../components/Daily20Quiz/daily20QuizSelectors';
import { getShowPdfViewer } from '../components/Dashboard/dashboardSelectors';
import { getShowMobileMenu } from '../components/Headers/headersSelector';
import {
  getSubscriptionActivationMessage,
  getSubscriptionActivationSuccess,
  getSubscriptionActivationWaiting,
  getSubscriptionOperationMessage,
  getSubscriptionOperationSuccess,
  getSubscriptionOperationWaiting,
} from '../components/ManageSubscription/ManageSubscriptionSelectors';
import { getPracticeExamAvailable } from '../components/PracticeExam/PracticeExamSelectors';
import { getLoading, getUser } from '../components/User/userSelectors';
import MainLayout from '../layouts/Main/mainLayout';
import { verifyLoggedUser } from '../utils/verifyUserLogged';

const mapStateToProps = (state, ownProps) => ({
  quiz: getQuiz(state),
  user: getUser(state),
  quizAvailable: quizAvailableSelector(state),
  timer: timerSelector(state),
  showMobileMenu: getShowMobileMenu(state),
  checkDailyQuizStatusWaiting: getCheckDailyQuizStatusWaiting(state),
  nextQuizIn: getNextQuizIn(state),
  dailyQuizRunning: getDailyQuizRunning(state),
  progress: getProgress(state),
  practiceExamAvailable: getPracticeExamAvailable(state),
  questionNotification: getQuestionNotificationSelector(state),
  loadingUser: getLoading(state),
  possibleCyclesForUser: getPossibleCyclesForUser(state),
  rates: getAllPublicRates(state),
  updateRatingExamWaiting: getUpdateRatingExamWaiting(state),
  updateRatingExamMessage: getUpdateRatingExamMessage(state),
  dailyTimeOut: getDailyTimeOut(state),
  userSubscription: getUserSubscription(state),
  subscriptionOperationMessage: getSubscriptionOperationMessage(state),
  subscriptionOperationWaiting: getSubscriptionOperationWaiting(state),
  subscriptionOperationSucces: getSubscriptionOperationSuccess(state),
  subscriptionActivationMessage: getSubscriptionActivationMessage(state),
  subscriptionActivationWaiting: getSubscriptionActivationWaiting(state),
  subscriptionActivationSucces: getSubscriptionActivationSuccess(state),
  isQualDailyQuizLoading: getIsQualDailyQuizLoading(state),
  isQualDailyQuizRunning: getIsQualDailyQuizRunning(state),
  nextQualDailyQuizIn: getNextQualDailyQuizIn(state),
  qualDailyQuizProgress: getQualDailyQuizProgress(state),
  qualDailyQuizTimeout: getQualDailyQuizDailyTimeOut(state),
  showPdfViewer: getShowPdfViewer(state),
  pfeSktId: getSwitchPfeSkt(state),
});

const mapDispatchToProps = (dispatch) => ({
  // Start timer starts the countdown time to do the daily quiz.
  startTimer: (timer) => {
    dispatch(startTimer());
    // This will keep decreasing the timer until timer gets 0.
    const interval = setInterval(() => {
      if (timer > 0) {
        dispatch(updateTimer());
      }
      timer -= 1;
      if (timer === 0) {
        clearInterval(interval);
      }
    }, 1000);
  },
  setInitialTimer: (time) => dispatch(setInitialTime(time)),
  openPdfViewer: (value) => dispatch(openPdfViewer(value)),
  setShowMobileMenu: (show) => dispatch(setShowMobileMenu(show)),
  checkDailyQuizStatus: () => dispatch(checkDailyQuizStatus()),
  setDailyQuiz: (value) => dispatch(setDailyQuiz(value)),
  setBackTo: (backTo) => dispatch(setBackTo(backTo)),
  verifyLoggedUser: () => verifyLoggedUser(),
  getWeeklyPracticeExams: () => dispatch(getWeeklyPracticeExams()),
  activateReceiveQuestionsNotification: (active, description) =>
    dispatch(activateReceiveQuestionsNotification(active, description)),
  loadPossibleCyclesForUser: (user) =>
    dispatch(loadPossibleCyclesForUser(user)),
  getAllRates: () => dispatch(getAllRates()),
  updateRatingExam: (id, rate, rank, dutyState, cycleSelected) =>
    dispatch(updateRatingExam(id, rate, rank, dutyState, cycleSelected)),
  getLoggedStudent: () => dispatch(getLoggedStudent()),
  setDailyTimeOut: (value) => dispatch(setDailyTimeOut(value)),
  getPdfByReference: (payload) => dispatch(getPdfByReference(payload)),
  activateSubscription: () => {
    dispatch(activateSubscription());
  },
  loadUserSubscription: () => dispatch(loadUserSubscription()),
  setFlashSectionChoose: (value) => dispatch(setFlashSectionChoose(value)),
  checkQualDailyQuizStatus: () => dispatch(checkQualDailyQuizStatus()),
  setQualDailyQuiz: (quiz) => dispatch(setQualDailyQuiz(quiz)),
  setOneQualDailyQuizHistory: (quiz) => setOneQualDailyQuizHistoryAction(quiz),
});

const MainContainer = connect(mapStateToProps, mapDispatchToProps)(MainLayout);

export default MainContainer;
